import React from "react";
import { Box, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/AddOutlined";
import RemoveIcon from "@mui/icons-material/RemoveOutlined";

// The single control that folds the navigation section away and brings it back,
// centered under the bookmarks grid. It reads as plain white text with a
// leading minus/plus rather than a button - the launchpad's surface is the
// brand gradient and a filled button would fight it.
export default function DashboardNavToggle({ hidden, onToggle }) {
  const Icon = hidden ? AddIcon : RemoveIcon;
  const label = hidden ? "Show navigation" : "Hide navigation";

  return (
    <Box
      role="button"
      tabIndex={0}
      aria-label={label}
      aria-expanded={!hidden}
      onClick={onToggle}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onToggle();
        }
      }}
      sx={{
        display: "flex",
        alignItems: "center",
        alignSelf: "center",
        cursor: "pointer",
        userSelect: "none",
        color: "#FFFFFF",
        opacity: 0.9,
        transition: "opacity 120ms",
        "&:hover": { opacity: 1 },
        "&:focus-visible": {
          outline: "2px solid #FFFFFF",
          outlineOffset: 4,
          borderRadius: 1,
        },
      }}
    >
      <Icon sx={{ fontSize: 18 }} />
      <Typography sx={{ fontSize: 14, letterSpacing: "-0.5px" }}>
        {label}
      </Typography>
    </Box>
  );
}
